import { NgForm } from '@angular/forms';

export class FormValidationUtil {

    static isFieldError(form: NgForm, fieldName: string, errorCode: string | string[]): boolean {
        let field = form.controls[fieldName];
        if (field == null) {
            return false;
        }

        if (errorCode == null) {
            if (field.enabled && field.invalid && !field.pristine) {
                return true;
            }
        } else {
            if (errorCode instanceof Array) {
                for (let code of errorCode) {
                    if (field.enabled && field.invalid && !field.pristine && field.hasError(code)) {
                        return true;
                    }
                }
                return false;
            } else {
                if (field.enabled && field.invalid && !field.pristine && field.hasError(errorCode)) {
                    return true;
                }
            }

        }
        return false;
    }

    static isFieldErrorSkipPristine(form: NgForm, fieldName: string, errorCode: string | string[]): boolean {
        let field = form.controls[fieldName];
        if (field == null) {
            return false;
        }

        if (errorCode == null) {
            if (field.enabled && field.invalid) {
                return true;
            }
        } else {
            if (errorCode instanceof Array) {
                for (let code of errorCode) {
                    if (field.enabled && field.invalid && field.hasError(code)) {
                        return true;
                    }
                }
                return false;
            } else {
                if (field.enabled && field.invalid && field.hasError(errorCode)) {
                    return true;
                }
            }

        }
        return false;
    }

    static isFieldDirty(form: NgForm, fieldName: string): boolean {
        let field = form.controls[fieldName];
        if (field == null) {
            return false;
        }

        if (!field.enabled) {
            return false;
        }

        return field.dirty;
    }
}